import React from "react"

// Components
import "./style.css"

const BigSpacer = () => {
    return <div className="big-spacer" />
}

export default BigSpacer



// WEBPACK FOOTER //
// ./src/components/BigSpacer/index.js